import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "pos-configs-dialog"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 1,
  class: "d-flex fl-col fl-j-c fl-a-c pos-configs-text"
};
var _hoisted_4 = {
  key: 1,
  class: "progress-container"
};
var _hoisted_5 = {
  key: 2
};
var _hoisted_6 = {
  key: 0,
  class: "pos-configs-text"
};
var _hoisted_7 = {
  class: "configs-wrapper"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "config-name two-lines"
};
var _hoisted_10 = {
  class: "config-description one-line"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_divider = _resolveComponent("el-divider");

  var _component_Spinner = _resolveComponent("Spinner");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    title: _ctx.$t('posconfiguration.title'),
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "before-close": _ctx.handleBeforeClose,
    "data-cy": "pos-config-modal"
  }, {
    footer: _withCtx(function () {
      return [];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_divider), (!_ctx.configs || !_ctx.configs.length) && !_ctx.loading || _ctx.adminUserWithoutGroup ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("posconfiguration.nosettings")), 1)) : _ctx.loading || _ctx.configLoading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.getLoadingText), 1), _ctx.loading ? (_openBlock(), _createBlock(_component_Spinner, {
        key: 0
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_progress, {
        percentage: _ctx.progressValue
      }, null, 8, ["percentage"])]))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_ctx.configs && _ctx.configs.length && !_ctx.loading ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("posconfiguration.text")), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configs, function (config) {
        return _openBlock(), _createElementBlock("div", {
          key: config.id,
          class: "config-card",
          onClick: function onClick($event) {
            return _ctx.confirmSelectConfig(config);
          },
          "data-cy": "pos-config-card"
        }, [_createElementVNode("p", _hoisted_9, _toDisplayString(config.name), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(config.description), 1)], 8, _hoisted_8);
      }), 128))])]))];
    }),
    _: 1
  }, 8, ["modelValue", "title", "before-close"])]);
}